import API from 'utils/api';

import { AddStatisticsRequest, AddStatisticsResponse } from './types';

export const addStatistic = (params: AddStatisticsRequest) => {
    return API.post<AddStatisticsResponse>(`Statistics/AddStatistic`, params);
};
